import React, { useEffect, useState } from "react";
import { Row, Card, CardBody, Modal, ModalBody, Col } from "reactstrap";
import Select from "react-select";
import "./styles.scss";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AvForm } from "availity-reactstrap-validation";
import SuccessModal from "components/SucessModal";
import FileUpload from "components/Common/file-upload/file-upload.component";
import ResaleService from "services/Website/ResaleService";
import CallModal from "./CallModal";
import MessageModal from "./MessageModal";
import { SuccessOk } from "configs/statusCode";
import { useTranslation } from "react-i18next";
import {
	FileMetaData,
	ImagePreview,
	PreviewContainer,
	RemoveFileIcon,
	ShowContent,
} from "components/Common/file-upload/file-upload.styles";

const BuyUnitModal = (props) => {
	const { t } = useTranslation();
	const { modal, setModal, details, unitType, propsList } = props;
	const service = new ResaleService();
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const [agree, setAgree] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	const [mediaIds, setMediaIds] = useState([]);
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [type, setType] = useState(unitType);
	const [complain, setComplain] = useState(false);
	const [loading, setLoading] = useState(false);
	const [bankAccount, setBankAccount] = useState({});
	const [formData, setFormData] = useState({
		payment: "",
		images_ids: [],
		payment_plan: "",
		deposit: "",
	});

	useEffect(() => {
		if (unitType === "") {
			if (!!details?.size) {
				setType("property");
			} else {
				setType("resale");
			}
		}
		service
			.getComplainStatus()
			.then((res) => res.data === "Complain" && setComplain(true));

		if (!!details.reciept) {
			let payment_plan = details?.payment_plans?.filter(
				(res) => res.payment_paln?.name?.en === details?.payment_plan_name
			)[0];
			setFormData({
				...formData,
				payment: { label: "BANK TRANSFER", value: "BANK TRANSFER" },
				images_ids: [details.reciept.id],
				payment_plan: {
					id: payment_plan?.payment_paln?.id,
					value: payment_plan?.payment_paln?.id,
					label: payment_plan?.payment_paln?.name?.en,
					...payment_plan?.payment_paln?.name,
				},
			});
			setAgree(true);
			setMediaIds([...mediaIds, details.reciept.id]);
		}
	}, []);

	useEffect(() => {
		if (
			type === "property" &&
			formData.payment?.value === "BANK TRANSFER" &&
			!!details?.developer?.bank_account?.length
		) {
			let defaultBank = details?.developer?.bank_account?.find(
				(res) => res?.currency === "EGP"
			);
			let filter = details?.developer?.bank_account?.find(
				(res) => res?.currency === currency?.currency_code
			);
			setBankAccount(filter || defaultBank);
		}
		if (type === "resale") {
			setBankAccount({
				iban: details?.iban,
				swift: details?.swift,
				account: details?.bank_account,
			});
		}
	}, [formData.payment, currency, type]);

	const handleComplain = () => {
		service.sendComplain().then((res) => {
			if (res && res.status === SuccessOk) {
				setComplain(true);
				toast.success("Send Complain Successfully");
			}
		});
	};

	const updatedAttachment = (attachments) => {
		const ids = attachments.map((res) => res.id);
		setFormData({ ...formData, images_ids: [...formData.images_ids, ...ids] });
	};

	const deleteAttachment = (Items) => {
		let updatedMedia = formData.images_ids?.filter(
			(item) => item !== Items[0].id
		);
		setFormData({ ...formData, images_ids: updatedMedia });
	};

	const handleSubmit = () => {
		let data = {
			deal_id: details.deal_id,
			reciept_id: formData.images_ids[0],
		};
		if (!formData.payment) {
			return toast.error("Select Type of Payment");
		}
		if (formData.payment.label === "CASH ON MEETING") {
			setLoading(true);
			service.buyCashOnMeeting(details.deal_id).then((res) => {
				if (res && res.status === SuccessOk) {
					setSuccessModal(true);
					setLoading(false);
				}
			});
		} else {
			if (formData.images_ids.length === 0) {
				return toast.error("Upload Receipt Required");
			}
			if (!formData?.payment_plan) {
				return toast.error("Select Payment Plan");
			}
			data["payment_plan_name"] = formData?.payment_plan?.label;
			let deposit = details.payment_plans?.filter(
				(res) => res?.payment_paln?.id === formData?.payment_plan?.id
			)[0]?.depost;
			data["deposit"] = parseFloat(deposit);

			setLoading(true);
			service.buyBankTransfer(data).then((res) => {
				if (res && res.status === SuccessOk) {
					setSuccessModal(true);
					setLoading(false);
				}
			});
		}
	};

	return (
		<Modal
			scrollable
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{ maxWidth: "1000px", width: "100%" }}
			className={`${
				AuthData.lang !== "ar" ? "resalePage p-0" : "ar-wrapper resalePage p-0"
			} ${formData.payment.label === "BANK TRANSFER" ? "bgModal" : "bgModal"}`}>
			<Row className="align-items-start">
				<Col xs={11}>
					<h4 className="mt-3 bask-font text-center fs-1 text-primary">
						{t("Buy The Unit")}
					</h4>
				</Col>
				<Col xs={1}>
					<button
						type="button"
						onClick={() => setModal(false)}
						className="close m-auto me-5 mt-3"
						data-dismiss="modal"
						aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</Col>
			</Row>
			<ModalBody className="m-0 p-0">
				<Card
					className="overflow-hidden m-0 p-0 bgModal"
					style={{ direction: "inherit" }}>
					<CardBody className=" p-0 m-0">
						<Row className="mx-4 my-3">
							<Col md={12}>
								<p className="font-size-22 mb-0 fw-bold text-primary">
									Type of Payment
								</p>
								<Select
									name="payment"
									placeholder="Select"
									className="mt-2 "
									options={[
										{ label: "BANK TRANSFER", value: "BANK TRANSFER" },
										{ label: "CASH ON MEETING", value: "CASH ON MEETING" },
									]}
									// value={{label: paymentOptions}}
									value={formData.payment}
									onChange={(data) => {
										if (!details.reciept) {
											setFormData({ ...formData, payment: data });
										}
									}}
								/>
							</Col>

							<Col md={12}>
								<h5
									className="mt-1 opacity mb-4 text-color"
									style={{ fontSize: "10px" }}>
									Now you will pay a deposit to hold the unit
								</h5>
							</Col>

							{formData.payment.label === "BANK TRANSFER" && (
								<>
									<Col md={12} className="mb-3">
										<p className="font-size-22 mb-0 fw-bold text-primary">
											Payment Plan
										</p>
										<Select
											name="payment_plan"
											placeholder="Select"
											className="mt-2 "
											options={
												details?.payment_plans?.length > 0
													? [
															...details?.payment_plans
																?.map((res) => {
																	return {
																		label: res?.payment_paln?.name?.en,
																		value: res?.payment_paln?.name?.en,
																		id: res?.payment_paln?.id,
																	};
																})
																.filter((obj, index) => {
																	return (
																		index ===
																		details?.payment_plans.findIndex(
																			(o) => obj.id === o?.payment_paln.id
																		)
																	);
																}),
													  ]
													: []
											}
											value={formData.payment_plan}
											onChange={(data) => {
												setFormData({ ...formData, payment_plan: data });
											}}
										/>
									</Col>

									<AvForm className="mt-2" onValidSubmit={() => handleSubmit()}>
										<Row>
											{type === "property" && (
												<Col lg={3} md={6}>
													<p
														className="font-size-14 fw-bold text-black mb-0"
														style={{ fontWeight: "500" }}>
														Account Name :
													</p>
													<h5
														className="font-size-12 text-primary"
														style={{ fontWeight: "400" }}>
														{bankAccount.name}
													</h5>
												</Col>
											)}
											<Col lg={3} md={6}>
												<p
													className="font-size-14 fw-bold text-color mb-0"
													style={{ fontWeight: "500" }}>
													IBAN No. :
												</p>
												<h5
													className="font-size-12 text-primary"
													style={{ fontWeight: "400" }}>
													{bankAccount.iban}
												</h5>
											</Col>
											<Col lg={3} md={6}>
												<p
													className="font-size-14 fw-bold text-color mb-0"
													style={{ fontWeight: "500" }}>
													Swift Code :
												</p>
												<h5
													className="font-size-12 text-primary"
													style={{ fontWeight: "400" }}>
													{bankAccount.swift}
												</h5>
											</Col>
											<Col lg={3} md={6}>
												<p
													className="font-size-14 fw-bold text-color mb-0"
													style={{ fontWeight: "500" }}>
													Account Number :
												</p>
												<h5
													className="font-size-12 text-primary"
													style={{ fontWeight: "400" }}>
													{bankAccount.account}
												</h5>
											</Col>
											<Col lg={3} md={6}>
												<p
													className="font-size-14 fw-bold text-color mb-0"
													style={{ fontWeight: "500" }}>
													Deposit:
												</p>
												<h5
													style={{ fontWeight: "400" }}
													className="font-weight-light font-size-12 text-primary">
													{toCurrency(
														details.payment_plans?.filter(
															(res) =>
																res?.payment_paln?.id ===
																formData?.payment_plan?.id
														)[0]?.depost || ""
													)}{" "}
													{currency?.currency_code}
												</h5>
												{/* <h5 style={{fontWeight: '400'}} className="font-weight-light">{type!=='resale' ? toCurrency(details.payment_plan?.filter(res=> res?.payment_paln?.name?.en == formData?.payment_plan?.label)[0]?.depost) : ''} EGP</h5> */}
											</Col>
											<Col
												md={12}
												className="mt-2 text-label font-size-22 fw-bold text-primary">
												{!details.reciept ? (
													<FileUpload
														accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG,.pdf,.doc,.docx"
														label="Upload Receipt"
														attachmentType="media_id"
														setUpload={() => {}}
														attachmentData={mediaIds}
														updatedAttachment={updatedAttachment}
														deleteAttachment={deleteAttachment}
														multiple
													/>
												) : (
													<PreviewContainer className="mb-3 mt-2 m-auto w-50">
														<div>
															<ImagePreview
																src={details.reciept.path}
																alt={`file preview`}
															/>
															<FileMetaData>
																<aside>
																	<ShowContent
																		href={details.reciept.path}
																		target="_blank"
																		rel="noopener noreferrer">
																		<RemoveFileIcon className="fas fa-eye" />
																	</ShowContent>
																</aside>
															</FileMetaData>
														</div>
													</PreviewContainer>
												)}
											</Col>
											<Col md="12">
												<div className="d-md-flex justify-content-center gap-2">
													<div>
														<button
															className="btn w-100 mb-2 py-3 px-4 text-center btn-primary rounded-pill"
															type="button"
															onClick={() => setCallModal(true)}>
															<i className="fa me-2 fa-phone"></i>
															CALL
														</button>
													</div>
													<div>
														<button
															className="btn w-100 mb-2 py-3 px-4 text-center btn-primary rounded-pill"
															onClick={() => setMessageModal(true)}
															type="button">
															<i className="fa me-2 fa-envelope"></i>
															MESSAGE
														</button>
													</div>
													<div>
														<button
															className="btn w-100 mb-2 py-3 px-4 text-center btn-primary rounded-pill"
															onClick={() => handleComplain()}
															type="button"
															disabled={complain}>
															<i class="fa me-2 fa-paper-plane"></i>
															COMPLAIN
														</button>
													</div>
												</div>
											</Col>

											<Col md={12} className="mt-2 text-center">
												<Row className="justify-content-center">
													<Col md={6}>
														<label style={{ fontSize: "15px" }}>
															<input
																name="agree"
																type="checkbox"
																required
																checked={agree}
																onChange={(e) => setAgree(e.target.checked)}
															/>
															Kindly read the{" "}
															<a href="#" className="text-primary">
																terms & conditions
															</a>{" "}
															before transfer, Then approve it
														</label>
													</Col>
												</Row>
											</Col>

											<Col md={12} className="mt-3">
												<Row className="justify-content-center">
													<Col md={6}>
														<button
															className="btn w-100 py-3 text-center rounded-pill btn-primary"
															type="submit"
															disabled={!agree || !!details.reciept || loading}>
															Submit
														</button>
													</Col>
												</Row>
											</Col>
										</Row>
									</AvForm>
								</>
							)}

							{formData.payment.label !== "BANK TRANSFER" && (
								<Row className="justify-content-center">
									<Col lg={12}>
										<div className="d-lg-flex gap-3 justify-content-center">
											<div>
												<button
													className="btn w-100 mb-2 py-3 text-center btn-primary px-4 rounded-pill"
													type="button"
													onClick={() => setCallModal(true)}>
													<i className="fa me-2 fa-phone"></i>
													CALL
												</button>
											</div>
											<div>
												<button
													className="btn w-100 mb-2 py-3 text-center btn-primary px-4 rounded-pill"
													onClick={() => setMessageModal(true)}
													type="button">
													<i className="fa me-2 fa-envelope"></i>
													MESSAGE
												</button>
											</div>
											<div>
												<button
													className="btn w-100 mb-2 py-3 text-center btn-primary px-4 rounded-pill"
													onClick={() => handleComplain()}
													type="button"
													disabled={complain}>
													<i class="fa me-2 fa-paper-plane"></i>
													COMPLAIN
												</button>
											</div>
										</div>
									</Col>

									<Col md={6} className="mt-4">
										<button
											className="btn w-100 py-3 text-center btn-primary rounded-pill"
											onClick={() => handleSubmit()}
											disabled={loading}>
											Submit
										</button>
									</Col>
								</Row>
							)}
						</Row>
					</CardBody>
				</Card>
			</ModalBody>

			{successModal && (
				<SuccessModal
					modal={successModal}
					title={"Successfuly buy steps"}
					subtitle={""}
					message={
						"your receipt will be reviewed as soon as possible, Then directly one of our members willcontact you"
					}
					onClick={() => propsList.history.push(`/`)}
				/>
			)}
			{callModal && (
				<CallModal
					modal={callModal}
					setModal={setCallModal}
					phone={details?.phone ? details?.phone : details?.sales_rep?.phone}
				/>
			)}

			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={details}
					type={details?.total_built_up_area ? "resale" : "unit"}
				/>
			)}
		</Modal>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default BuyUnitModal;
